import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  containerQueryProps,
  getTranslation,
  Icon,
  TranslationProvider,
  Link,
} from '@resy/ui-kitchen';
import BlogNavBlurb from '../../BlogNavBlurb/BlogNavBlurb';

import Twitter from '../../../../../../ui-kitchen/src/svg/icons/twitter.svg';
import Instagram from '../../../svg/dynamic/Instagram.svg';
import Facebook from '../../../svg/dynamic/Facebook.svg';

import './HeroDetails.scss';

const HeroDetails = (props) => {
  const {
    blogNavLinks,
    locationCode,
    containerQuery: { lg, xl },
  } = props;

  return (
    <div
      className={cx('HeroDetails', {
        'HeroDetails--mobile': (!(lg || xl)),
      })}
      aria-label={getTranslation({
        translationKey: 'blog_hero_label',
        fallback: 'About Resy, statistics, and social media links',
      })}
    >
      <div className="HeroDetails__Wrapper">
        <BlogNavBlurb blogNavLinks={blogNavLinks} />
      </div>

      {lg && <hr aria-hidden="true" />}

      <h2 className="about-resy-link-header">
        <TranslationProvider translationKey="about_resy_link">
          <Link
            href="/about-and-help"
            className="HeroDetails__Title"
            variant="article"
          >
            About Resy
          </Link>
        </TranslationProvider>
      </h2>

      <div className="HeroDetails__Wrapper">
        <div className={cx('HeroDetails__SocialMedia', {
          'HeroDetails__SocialMedia--xl': xl,
        })}
        >
          <Link
            href={locationCode === 'ldn' ? 'https://www.instagram.com/resylondon' : 'https://www.instagram.com/resy'}
            rel="noopener noreferrer"
            target="_blank"
            aria-label={getTranslation({
              translationKey: 'resy_instagram',
              fallback: 'Resy Instagram',
            })}
          >
            <Icon name="Instagram" component={Instagram} />
          </Link>

          <Link
            href="https://www.twitter.com/resy"
            rel="noopener noreferrer"
            target="_blank"
            aria-label={getTranslation({
              translationKey: 'resy_twitter',
              fallback: 'Resy Twitter',
            })}
          >
            <Icon name="twitter" component={Twitter} />
          </Link>

          <Link
            href="https://www.facebook.com/resy"
            rel="noopener noreferrer"
            target="_blank"
            aria-label={getTranslation({
              translationKey: 'resy_facebook',
              fallback: 'Resy Facebook',
            })}
          >
            <Icon name="Facebook" component={Facebook} />
          </Link>
        </div>
      </div>

    </div>
  );
};

HeroDetails.propTypes = {
  locationCode: PropTypes.string,
  blogNavLinks: PropTypes.shape({
    cityName: PropTypes.string,
    willAppendCity: PropTypes.bool,
    slug: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    })),
  }),
  containerQuery: containerQueryProps,
};

HeroDetails.defaultProps = {
  locationCode: 'ny',
  blogNavLinks: {
    cityName: null,
    willAppendCity: false,
    slug: null,
    links: null,
  },
  containerQuery: {},
};

HeroDetails.displayName = 'HeroDetails';
export default HeroDetails;
